import { render, staticRenderFns } from "./InstructorCreate.vue?vue&type=template&id=7da13afa&"
import script from "./InstructorCreate.vue?vue&type=script&lang=js&"
export * from "./InstructorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports